import { createFileRoute } from '@tanstack/react-router';
import { AccountPage } from '@/features/account/AccountPage';

export const Route = createFileRoute('/app/account/')({
  component: AccountPage,
  staticData: { title: 'Account' },
});
